<template>
   <div class="sideBanner">
      <div class="filter">
        <router-link class="nav-link" to="about" title="Denys Photos Photography">
         <div class="content">
            <h1>Denys Photos</h1>
         </div>
         </router-link>
         <ul class="list-unstyled list-inline text-center">
            <li v-for="(setting,key) in settings" v-if="setting.value!=''" :key="key" class="list-inline-item">
              <a target="_blank" :href="setting.value" class="btn-floating mx-1">
              <i :class="setting.font" aria-hidden="true"> </i>
              </a>
            </li>
        </ul>
      </div>
   </div>                        
</template>

<script>
import axios from 'axios';
export default {
  name: 'banner',

  data () {
    return {
      settings:[]
    }
  },
  methods: {
    getSettings: function(){
      var that=this;
      axios.get("http://denys.photos/admin/api.php?action=getSettings").then(function(response){
        that.settings=response.data.settings;
      });
    }
  },
  created: function(){
    this.getSettings();
  }
   
}
   
</script>
<style lang="scss" scoped>
$fa-font-path: "~font-awesome/fonts";
@import '~font-awesome/scss/font-awesome.scss';
@import url('https://fonts.googleapis.com/css?family=Amatic+SC|Amita|Aref+Ruqaa|Arima+Madurai:100,200|Asar|BenchNine:700|Galada|Gidugu|Itim');

div.sideBanner{
   /*background-image: url("https://s-media-cache-ak0.pinimg.com/originals/6e/65/43/6e6543730023c12f228692d502a4f2d2.jpg");*/
   background-image: url("http://denys.photos/admin/uploads/937E7432-CADC-4861-B8C2-2287E2C37C99.jpeg");
   background-position:-105px 0px;
   background-repeat: no-repeat;
   background-size:auto 100%;
}
.filter{
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+71,222222+96&0+78,1+98 */
  background: -moz-linear-gradient(left, rgba(255,255,255,0) 71%, rgba(193,193,193,0) 78%, rgba(34,34,34,0.9) 96%, rgba(34,34,34,1) 98%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(255,255,255,0) 71%,rgba(193,193,193,0) 78%,rgba(34,34,34,0.9) 96%,rgba(34,34,34,1) 98%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255,255,255,0) 71%,rgba(193,193,193,0) 78%,rgba(34,34,34,0.9) 96%,rgba(34,34,34,1) 98%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#222222',GradientType=1 ); /* IE6-9 */
  height: inherit;
  ul{
    font-size: 30px;
  }
}

.content,h1,h2,h3,h4,p,i,span{
  text-align:center;
  font-family: 'Amatic SC', cursive;
  font-size: 60px;
  font-weight: 595;
  color:whitesmoke;
  padding:2px;
}
ul.list-unstyled.list-inline.text-center{
  position:absolute;
  bottom:0%;
}

    
</style>





// WEBPACK FOOTER //
// src/components/banner.vue